import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../../feature'
import type { Manager } from '../manager'

export const cleanUpCytoscape = store.effects.create(
  (feature: Feature, manager: Manager) =>
    feature.actions.cleanUp.observe().pipe(
      rxjs.map(({ data: { chartId: orgChartId } }) => {
        manager.resetLayout({ chartId: orgChartId })
      }),
      rxjs.ignoreElements(),
    ),
)
